import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'editor'
const user = JSON.parse(localStorage.getItem('user'))
if (user && user.role == 3) {
  initialRole = 'admin'
}
if (user && user.role == 4) {
  initialRole = 'company'
}

export default new AclCreate({
  initial: initialRole,
  notfound: '/pages/not-authorized',
  router,
  acceptLocalRules: true,
  globalRules: {
    admin: new AclRule('admin').generate(),
    company: new AclRule('company').generate(),
    editor: new AclRule('editor').or('admin').or('company').generate()
  }
})
